<template>
<!--Navigation-->
<div id="navigation">
  <div id="content_navigation">
    <a href="javascript:history.back()"><div class="sprite back butt_black left" title="Go Back"></div></a>
    <a href="" id="categories-button" @click="openMenu"><div class="sprite navigation butt_black right" title="Open Menu"></div></a>
    <div id="categories-dropdown">
      <div class="categories-inside">
        <ul>
          <li><router-link :to="{path: '/buy'}">Buy Picks</router-link></li>
          <li><router-link :to="{path: '/testimonials'}">Testimonials</router-link></li>
          <li><router-link :to="{path: '/picks'}">View Picks</router-link></li>
          <li><router-link :to="{path: '/blog'}">Blog</router-link></li>
          <li><router-link :to="{path: '/results'}">Results</router-link></li>
          <li><router-link :to="{path: '/contact'}">Contact</router-link></li>
        </ul>
      </div>
    </div>
  </div>
</div>
<!--Navigation Ends-->
</template>

<script>
export default {
  data () {
    return {

    }
  },
  methods: {
    openMenu () {
      this.$router.push('/')
    }
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// Nav.vue?2226fc1e